import { call, put, select } from 'redux-saga/effects';
import { urls } from '../../../common/urls';
import { getHttp, getHttpwithtoken, postHttpwithtoken } from '../../../common/ApiCall';
import {
  loginFailure,
  loginLoading,
  loginSuccess,
  sendOtpFailure,
  sendOtpLoading,
  sendOtpSuccess,
  getCityDataFailure,
  getCityDataLoading,
  getCityDataSuccess,
  verifyEmailOrMobileFailure,
  verifyEmailOrMobileLoading,
  verifyEmailOrMobileSuccess,
  signUpFailure,
  signUpLoading,
  signUpSuccess,
  switchAccountFailure,
  switchAccountLoading,
  switchAccountSuccess,
  customerInfoFailure,
  customerInfoLoading,
  customerInfoSuccess,
} from '../../ducks/AuthSlice';

// Login Handler
export function* handlerLoginReq(action: any): Generator<any, void, any> {
  try {
    yield put(loginLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.login}`, action.payload);
    
    if (response.success) {
      yield put(loginSuccess(response));
    } else {
      yield put(loginFailure(response.message || 'Login failed'));
    }
  } catch (error: any) {
    yield put(loginFailure(error.message || 'Login failed'));
  }
}

// Send OTP Handler
export function* handlerSendOTP(action: any): Generator<any, void, any> {
  try {
    yield put(sendOtpLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.sendotp}`, action.payload);
    
    if (response.success) {
      yield put(sendOtpSuccess(response));
    } else {
      yield put(sendOtpFailure(response.message || 'Failed to send OTP'));
    }
  } catch (error: any) {
    yield put(sendOtpFailure(error.message || 'Failed to send OTP'));
  }
}

// Get City Data Handler
export function* handlerGetCity(action: any): Generator<any, void, any> {
  try {
    yield put(getCityDataLoading());
    const response: any = yield call(getHttp, `${urls.baseURL}${urls.getCities}`);
    
    if (response.success) {
      yield put(getCityDataSuccess(response.data));
    } else {
      yield put(getCityDataFailure(response.message || 'Failed to get cities'));
    }
  } catch (error: any) {
    yield put(getCityDataFailure(error.message || 'Failed to get cities'));
  }
}

// Verify Email or Mobile Handler
export function* handlerEmailOrMobileVerify(action: any): Generator<any, void, any> {
  try {
    yield put(verifyEmailOrMobileLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.verifymoboremail}`, action.payload);
    
    if (response.success) {
      yield put(verifyEmailOrMobileSuccess(response));
    } else {
      yield put(verifyEmailOrMobileFailure(response.message || 'Verification failed'));
    }
  } catch (error: any) {
    yield put(verifyEmailOrMobileFailure(error.message || 'Verification failed'));
  }
}

// Sign Up Handler
export function* handlerSignUpOrRegister(action: any): Generator<any, void, any> {
  try {
    yield put(signUpLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.register}`, action.payload);
    
    if (response.success) {
      yield put(signUpSuccess(response));
    } else {
      yield put(signUpFailure(response.message || 'Registration failed'));
    }
  } catch (error: any) {
    yield put(signUpFailure(error.message || 'Registration failed'));
  }
}

// Switch Account Handler
export function* handlerSwitchAccount(action: any): Generator<any, void, any> {
  try {
    yield put(switchAccountLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.switchAccount}`, action.payload);
    
    if (response.success) {
      yield put(switchAccountSuccess(response));
    } else {
      yield put(switchAccountFailure(response.message || 'Account switch failed'));
    }
  } catch (error: any) {
    yield put(switchAccountFailure(error.message || 'Account switch failed'));
  }
}

// Customer Info Handler
export function* handlerCustomerInfoMe(action: any): Generator<any, void, any> {
  try {
    yield put(customerInfoLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.me}`);
    
    if (response.success) {
      yield put(customerInfoSuccess(response.data));
    } else {
      yield put(customerInfoFailure(response.message || 'Failed to get customer info'));
    }
  } catch (error: any) {
    yield put(customerInfoFailure(error.message || 'Failed to get customer info'));
  }
}
